import { createFileRoute } from '@tanstack/react-router';

import { SupplierCustomersPage } from '@/features/supplier/customers-page';

export const Route = createFileRoute('/_app/supplier/$orgId/customers/')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <SupplierCustomersPage {...params} />;
}
